module.exports = __webpack_public_path__ + "img/product-penjaminan-kredit-mikro.864f8555.jpeg";